module.exports = __webpack_public_path__ + "static/media/SingleCoupon_store.869d0c1a.png";